import {NgModule} from '@angular/core';
import {ScrollToActiveDirective} from './scroll-to-active.directive';

@NgModule({
    declarations: [
        ScrollToActiveDirective
    ],
    exports: [
        ScrollToActiveDirective
    ]
})
export class ScrollToActiveModule {}
